import { create } from 'zustand';

export const useClockStore = create(set => ({
  clockData: {
    elapsed: 0,
    remaining: null,
    wallClock: null,
  },
  setClockData: (data) => set({ clockData: data }),
}));
